module.exports = __webpack_public_path__ + "static/media/EvenandOdd.190a80df.jpg";